import $ from 'cash-dom';
import FiltersSessionStorage from './FiltersSessionStorage';
import ExitPopup from "../../../components/exit-popup";
import FieldsBuilder from './FieldsBuilder';
import UrlHelper from '../../../components/UrlHelper';
import Settings from '../../../components/Settings';
import FiltersMixin from './mixins/FiltersMixin';
import spinner from '../../../components/spinner';
import Utils from '../../../components/Utils';
import BaseField from './fields/BaseField';

const VENDORS_SELECTOR = '.vendors-list .ppc-single-vendor';
let instance = null;

/**
 * @mixes FiltersMixin
 */
class PpcFilter {
	constructor() {
		if (instance) {
			return instance;
		}

		this._resetVendorsList();

		const $filtersHolder = $('.filters-holder');
		const $filters = $filtersHolder.closest('.filters');

		const exclusions = $filtersHolder.data('exclusions');
		this._exclusions = exclusions ? exclusions : [];
		const emptyFiltersExclusions = $filtersHolder.data('empty-filters-exclusions');
		this._emptyFiltersExclusions = Array.isArray(emptyFiltersExclusions) ? emptyFiltersExclusions : [];

		this._filtersAreVisualyHidden = $filters.length && $filters.hasClass('hidden');
		this._useArtificialWaiting = !!$filtersHolder.data('artificial-waiting');
		this._artificialWaitingTime = 500;
		this._fields = FieldsBuilder.build($filtersHolder);
		this._lastBIData = { aloomaData: null, filterName: null, filterValue: null };
		this._autoFilter = false;
		this._sendBiOnFilter = true;
		this._limit = $filtersHolder.data('limit') ? $filtersHolder.data('limit') : null;
		this._filtersLimit = $filtersHolder.data('filters-limit') ? $filtersHolder.data('filters-limit') : null;
		this._isPrequal = false;
		this._initialVendorsOrder = null;

		this._filter_click_index = +atob(UrlHelper.getParam(window.location.href, 'i', btoa(0)));
		this._filter_id = atob(UrlHelper.getParam(window.location.href, 'f', btoa('f-' + Alooma.aloomaPageData.pageview_id)));

		// chevron sync
		this._chevronSyncInited = false;
		this._syncChevron = (() => {
			const $list = $('.vendors-list');
			const itemSel = '.ppc-single-vendor.has-animated-description';

			return () => {
				if (!$list.length) return;

				const $items = $list.find(itemSel).not('.hidden');
				if (!$items.length) return;

				const $first = $items.eq(0);

				requestAnimationFrame(() => {
					$first[0].offsetHeight;

					// $first.addClass('anim-run')
					// 	.find('i').removeClass('hidden');

					$first.find('i').removeClass('hidden');
				});
			};
		})();
		this._initChevronSync = () => {
			if (this._chevronSyncInited) return;
			this._chevronSyncInited = true;
			$(document).on('filters-change', this._syncChevron);
			this._syncChevron();
		};

		Object.assign(this, FiltersMixin);

		instance = this;
	}

	get $vendorsList() {
		return this._$vendorsList;
	}

	get artificialWaitingTime() {
		return this._artificialWaitingTime;
	}

	get useArtificialWaiting() {
		return this._useArtificialWaiting;
	}

	setIsPrequal(isPrequal) {
		this._isPrequal = isPrequal;

		return this;
	}

	/**
	 * @returns {PpcFilter}
	 */
	static getInstance() {
		if (!instance) {
			instance = new PpcFilter();
		}

		return instance;
	}

	_resetVendorsList() {
		this._$vendorsList = $(VENDORS_SELECTOR).not('.cross-chart-inside-list-vendor');
	}

	init() {
		if (!this.hasFilters()) {
			this._initChevronSync();
			return;
		}

		$(document).on(BaseField.EVENT_FILTER_FIELD_CHANGE, (e, data) => {
			this._filter(e, data);
			this._initChevronSync();
		});
		$(document).on('PrequalifyModalHandler:prequalFilterApply', this._initChevronSync);

		this._setFiltersIfNeed();
		this._setHideVendorOverLimit();
		this._initMobileFilterHandlers();
		// next methods from mixin FiltersMixin
		this._initFiltersHeightCalculating();
		this._initFirstVendorHeightCalculating();
		this._initFiltersSticky();
		this._initHandlers();
		this._initChevronSync();
	}

	hasFilters() {
		return !!this._fields.size;
	}

	_setFiltersIfNeed() {
		const sessionFilters = FiltersSessionStorage.getInstance().getAndDeleteLastSelectedFilters();
		const defaultFilters = this._getDefaultFilters();
		let wasChange = false;

		if (sessionFilters) {
			const sessionFiltersWithValues = this._getFiltersWithValues(sessionFilters);
			wasChange = this.setFilters(sessionFiltersWithValues, true);
			// this._autoFilter = true;
		} else if (defaultFilters) {
			const defaultFiltersWithValues = this._getFiltersWithValues(defaultFilters);

			if (Object.keys(defaultFiltersWithValues).length) {
				this._autoFilter = true;
			}

			const useArtificialWaitingPreValue = this._useArtificialWaiting;
			this._useArtificialWaiting = false;

			wasChange = this.setFilters(defaultFiltersWithValues, true);

			this._useArtificialWaiting = useArtificialWaitingPreValue;
		} else {
			const vendorOrderData = this._sendBiWithEmptyFilters();
			this._refillIndexes();

			if (this._emptyFiltersExclusions.length) {
				this._refillIndexes();
				$(document).trigger('filters-change', { vendorOrderData, $vendorsList: this._$vendorsList });
			}
		}

		this._hideOrShowCrossChartInsideList();

		this._autoFilter = false;
	}

	_setHideVendorOverLimit() {
		let visibleIndex = 0;

		this._$vendorsList.each((i, vendor) => {
			const $vendor = $(vendor);

			if ($vendor.hasClass('hidden')) {
				return;
			}

			if (this._isOverLimit(visibleIndex)) {
				$vendor.addClass('hidden');
			}

			++visibleIndex;
		});
	}

	_getFiltersWithValues(filters) {
		const filtersWithValues = {};

		for (const [filterName, filterValue] of Object.entries(filters)) {
			if (filterValue) {
				filtersWithValues[filterName] = filterValue;
			}
		}

		return filtersWithValues;
	}

	_initMobileFilterHandlers() {
		const self = this;

		$(document).on('applyMobileFilters', function (e, { filters }) {
			if (filters && typeof filters === 'object') {
				const wasChange = self.setFilters(filters, false, true);

				if (!wasChange && self._lastBIData.aloomaData && Object.keys(self._lastBIData.aloomaData).length) {
					self._sendBIEvents(self._lastBIData);
				}
			}
		});
	}

	_getDefaultFilters() {
		const filtersJson = $('#default-filters').val();
		const defaultFilters = filtersJson ? JSON.parse(filtersJson) : null;

		if (defaultFilters !== null) {
			let allEmpty = true;

			for (const filterValue of Object.values(defaultFilters)) {
				if (filterValue) {
					allEmpty = false;
					break;
				}
			}

			if (allEmpty) {
				return null;
			}
		}


		return defaultFilters;
	}

	setFilters(filters, sendBiEventsOnLastFilter = false, forceSetAndTrigger = false) {
		let wasChange = false;

		if (!filters) {
			return wasChange;
		}

		const length = Object.keys(filters).length;
		let index = 0;
		const isLast = (index) => (index + 1) === length;
		this._sendBiOnFilter = !sendBiEventsOnLastFilter;

		for (const filterName in filters) {
			if (sendBiEventsOnLastFilter && isLast(index)) {
				this._allowToSendBiOnFilter();
			}
			const filterValue = filters[filterName];
			const valWasChanged = this.setValue({ filterName, filterValue, forceSetAndTrigger });

			if (!wasChange && valWasChanged) {
				wasChange = true;
			}

			++index;
		}

		this._allowToSendBiOnFilter();

		return wasChange;
	}

	_allowToSendBiOnFilter() {
		if (this._useArtificialWaiting) {
			setTimeout(() => {
				this._sendBiOnFilter = true;
			}, this._artificialWaitingTime);
		} else {
			this._sendBiOnFilter = true;
		}
	}

	_filter = (e, { filterName, currentFieldValue, redirectLink }) => {
		const isLinkTheSameAsCurrentUrl = UrlHelper.isLinkTheSameAsCurrentUrl(redirectLink);

		if (redirectLink && !isLinkTheSameAsCurrentUrl) {
			this._redirect(redirectLink);
			return;
		}

		if (this._useArtificialWaiting) {
			spinner.show();

			setTimeout(() => {
				this._processFilter({ filterName, currentFieldValue, isLinkTheSameAsCurrentUrl });
				spinner.hide();
			}, this._artificialWaitingTime)
		} else {
			this._processFilter({ filterName, currentFieldValue, isLinkTheSameAsCurrentUrl });
		}
	};

	_processFilter({ filterName, currentFieldValue, isLinkTheSameAsCurrentUrl }) {
		if (!filterName) {
			return;
		}

		if (!this._autoFilter && this._sendBiOnFilter) {
			++this._filter_click_index;
		}

		// Hardcode for SelectQuote vendor on US Life
		if (document.body.classList.contains('set-sub5-for-us-life') && filterName === 'what-is-your-annual-income') {
			Utils.addHardcodedSubIdToLinks(currentFieldValue, 769);
		}

		let { vendorsToShow, noFilters, hasVendorsWithOrder } = this._fields.getVendorsToShowAndOtherData(this._exclusions);

		if (isLinkTheSameAsCurrentUrl) {
			noFilters = true;
		}

		const deeplinks = this._fields.getNameAndDeeplinks();
		const currentDeeplinks = deeplinks ? deeplinks[filterName] : null;

		const vendorOrderData = this._initAndGetVendorOrderData({
			noFilters,
			vendorsToShow,
			deeplinks: currentDeeplinks,
			reorderVendors: hasVendorsWithOrder,
			filterField: this._fields.getFirst(filterName),
		});

		this._refillIndexes();

		if (this._sendBiOnFilter) {
			this._sendAloomaEvents(filterName, vendorOrderData, currentFieldValue);
		}

		ExitPopup.loadPopupHtml(true);

		const $crossChartInsideList = $('.vendors-list .cross-chart.position-inside-list');
		const crossChartInsideListPosition = $crossChartInsideList.data('position')
			? $crossChartInsideList.data('position')
			: 2;
		const insertAfterVendor = $('.vendors-list .ppc-single-vendor.ppc-vendor-' + crossChartInsideListPosition)
			.not('.hidden, .cross-chart-inside-list-vendor');

		if ($crossChartInsideList.length > 0 && insertAfterVendor.length > 0) {
			const detachCrossChart = $crossChartInsideList.detach();
			insertAfterVendor.after(detachCrossChart);
		}

		this._hideOrShowCrossChartInsideList();
		this._hideOrShowCrossCharts();


		this._calculateFirstVendorHeight();
		$(document).trigger('filters-change', { vendorOrderData, $vendorsList: this._$vendorsList, filterName });
	}

	// Ed's request
	_hideOrShowCrossChartInsideList(crossChartInsideList = null) {
		crossChartInsideList = crossChartInsideList
			|| $('.vendors-list .cross-chart.position-inside-list, .duplicated-list-holder .cross-chart-vendors-list .cross-chart.position-inside-list');

		if (!crossChartInsideList.length) {
			return;
		}

		const activeFilters = this.getActiveFilters();
		const loanAmountToShow = activeFilters['loan-amount'] === undefined
			|| activeFilters['loan-amount'] === ''
			|| activeFilters['loan-amount'] === 'more-than-3000';

		const creditScoreToShow = activeFilters['credit-score'] === undefined
			|| activeFilters['credit-score'] === ''
			|| activeFilters['credit-score'].startsWith('excellent')
			|| activeFilters['credit-score'].startsWith('good')
			|| activeFilters['credit-score'].startsWith('fair');

		if (loanAmountToShow && creditScoreToShow) {
			crossChartInsideList.removeClass('hidden');
		} else {
			crossChartInsideList.addClass('hidden');
		}
	}

	_hideOrShowCrossCharts() {
		const activeFilters = this.getActiveFilters();

		const crossChartsConfig = [
			{
				selector: '.cross-chart.position-1.hide-on-filter',
				loanAmountToShow: ['15000-35000', 'more-than-35000'],
				creditScoreToShow: ['excellent-720-850', 'good-690-719', 'fair-630-689']
			},
			{
				selector: '.cross-chart.position-2.hide-on-filter',
				loanAmountToShow: ['15000-35000', 'more-than-35000'],
				creditScoreToShow: ['excellent-720-850', 'good-690-719', 'fair-630-689', 'poor-350-629']
			}
		];

		crossChartsConfig.forEach(config => {
			const $crossChart = $(config.selector);

			if (!$crossChart.length) {
				return;
			}

			const showByLoan = config.loanAmountToShow.includes(activeFilters['loan-amount']);
			const showByScore = config.creditScoreToShow.includes(activeFilters['credit-score']);

			if (showByLoan && showByScore) {
				$crossChart.removeClass('hidden');
			} else {
				$crossChart.addClass('hidden');
			}
		});
	}

	_redirect(redirectLink) {
		const filters = this._fields.getFieldsNameAndValue();
		FiltersSessionStorage.getInstance().setLastSelectedFilters(filters);

		redirectLink = UrlHelper.addParam(redirectLink, 'i', btoa(this._filter_click_index));
		redirectLink = UrlHelper.addParam(redirectLink, 'f', btoa(this._filter_id));

		window.location.href = redirectLink;
	}

	getVisibleVendorOrderData() {
		const vendorOrderData = {};
		let visibleItemsIndex = 0;

		this._$vendorsList.each((i, vendor) => {
			const $singleVendor = $(vendor);
			const slug = $singleVendor.data('vendor-slug');

			if (slug && !$singleVendor.hasClass('hidden')) {
				vendorOrderData[slug] = this._buildAndGetVendorOrderDatum($singleVendor, visibleItemsIndex++)
			}
		});

		return vendorOrderData;
	}

	_buildAndGetVendorOrderDatum($vendor, visibleItemsIndex) {
		return {
			position_id: visibleItemsIndex,
			vendorTitle: $vendor.data('vendor-title'),
			vendor_id: $vendor.data('vendor-id'),
		};
	}

	_sendAloomaEvents(filterName, vendorOrderData, filterValue) {
		const self = this;

		if (Alooma && !this._filtersAreVisualyHidden) {
			let aloomaData = {
				pageview_id: Alooma.aloomaPageData.pageview_id,
				vendorOrder: vendorOrderData,
				prequal: this._getIsPrequalAndResetValue(),
			};
			const filtersChangeData = self._buildAndGetFiltersChangeData();

			aloomaData = { ...aloomaData, ...filtersChangeData };

			self._lastBIData = { aloomaData, filterName, filterValue };
			self._sendBIEvents(self._lastBIData, vendorOrderData);
		}
	}

	_getIsPrequalAndResetValue() {
		const isPrequal = this._isPrequal ? 1 : 0;
		this._isPrequal = false;

		return isPrequal;
	}

	_sendBIEvents({ aloomaData, filterName, filterValue, filters = null }, vendorOrderData = null) {
		Alooma.aloomaSendEvent('filter_change', aloomaData);

		const filterChangeData = this._buildAndGetFiltersChangeData();
		document.body.dataset.filterChangeData = JSON.stringify(filterChangeData);

		if (!filterValue && filters && typeof filters === 'object') {
			filterValue = '';
			const filterValues = [];

			for (const [filterName, filterValue] of Object.entries(filters)) {
				filterValues.push(filterName + ': ' + filterValue);
			}

			filterValue = filterValues.join(', ');
		}

		if (typeof GAEvents !== 'undefined') {
			GAEvents.sendEvent(
				this._autoFilter ? 'Auto Filter' : 'Filter',
				filterName + ': ' + filterValue,
				window.location.href
			);
		}

		if (!this._autoFilter && vendorOrderData) {
			// Sallie Mae 302,  College Ave 617
			const specificFilterIds = [302, 617];

			for (const vendorOrderDatum of Object.values(vendorOrderData)) {
				if (specificFilterIds.includes(vendorOrderDatum.vendor_id)) {
					if (typeof GAEvents !== 'undefined') {
						GAEvents.sendEvent(
							'Filter_Specific',
							filterName + ': ' + filterValue,
							window.location.href
						);
					}
					break;
				}
			}
		}
	}

	setValue({ filterName, filterValue, autoFilter = false, forceSetAndTrigger = false }) {
		let wasChange = false;

		if (filterValue !== undefined && (this._fields.getFilterValue(filterName) !== filterValue || forceSetAndTrigger)) {
			if (autoFilter) {
				this._autoFilter = true;
			}

			this._fields.setValueAndTriggerEvent(filterName, filterValue);
			wasChange = true;

			if (autoFilter) {
				this._autoFilter = false;
			}
		}

		return wasChange;
	}

	getActiveFilters() {
		const filters = this._fields.getFieldsNameAndValue();

		return filters;
	}

	sortAndGetFiltersWithRedirectInLastPosition(filtersWithValuesToSort) {
		let filterNameWithRedirectLink = this._getFilterNameWithRedirectLink(filtersWithValuesToSort);

		if (!filterNameWithRedirectLink) {
			// no redirect link, no need to reorder
			return filtersWithValuesToSort;
		}

		// Extract all keys except filterNameWithRedirectLink, then add it at the end
		const keys = Object.keys(filtersWithValuesToSort).filter(key => key !== filterNameWithRedirectLink);
		keys.push(filterNameWithRedirectLink);

		const reordered = {};

		keys.forEach(key => {
			reordered[key] = filtersWithValuesToSort[key];
		});

		return reordered;
	}

	_getFilterNameWithRedirectLink(filters) {
		let filterNameWithRedirectLink = '';

		for (const [filterName, filterValue] of Object.entries(filters)) {
			const field = this._fields.getFirst(filterName);

			if (field && field.getRedirectLinkForValue(filterValue)) {
				filterNameWithRedirectLink = filterName;
				break;
			}
		}

		return filterNameWithRedirectLink;
	}
}

export default PpcFilter;
